<template>

  <div>

    <Index v-if="activeName == 'index'"></Index>
    <Menu v-if="activeName == 'menu'"></Menu>
    <Category v-if="activeName == 'category'"></Category>


    <Setting v-if="activeName == 'setting'"></Setting>

  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import Index from './index/index';
import Setting from './setting/getSetting';
import Category from './category/index.vue';
import Menu from './menu/index.vue';
import SupplyApi from '@/api/supply.js';

export default {
  components: {
    Index,
    Setting,
    Menu,
    Category,
  },
  data() {
    return {
      formInline: {
        nick_name: ''
      },
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'index',
      /*切换数组*/
      sourceList: [
        {
          key: 'index',
          value: '列表',
          path:'/plus/project_investment/index/index'
        },
          {
          key: 'category',
          value: '分类',
          path:'/plus/project_investment/category/index'
        },
            {
          key: 'menu',
          value: '类目',
          path:'/plus/project_investment/menu/index'
        },
        {
          key: 'setting',
          value: '设置',
          path:'/plus/project_investment/setting/getSetting'
        },
       
      ],
      /*权限筛选后的数据*/
      tabList:[],
      /*判断third是否有参数*/
      is_third_param: false
    };
  },
  watch:{

    //监听路由
    $route(to, from) {
      this.init();
    }
  },
  created() {

    this.init();
    this.updateRead()

  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type:'activity',list: [] });
    bus.$off('activeValue');
  },
  methods: {
     updateRead(){
      SupplyApi.updateRead({
       supply_id: this.supply_id,
       type:'11'
      }).then(res=>{

      })
       SupplyApi.updateRead({
       supply_id: this.supply_id,
       type:'25'
      }).then(res=>{

      })
    
    },
    /*初始化方法*/
    init(){
      this.tabList=this.authFilter();

      if(this.tabList.length>0){
        this.activeName=this.tabList[0].key;
      }

      if (this.$route.query.type != null) {
        this.activeName = this.$route.query.type;
      }

      /*监听传插件的值*/
      bus.$on('activeValue', res => {
        if (this.is_third_param) {
          this.param.user_id = '';
          this.is_third_param = false;
        }
        this.activeName = res;
      });

      //发送类别切换
      let params = {
        active: this.activeName,
        list: this.tabList,
        tab_type:'activity'
      };
      bus.$emit('tabData', params);
    },

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/project_investment/index.vue